import { Chip } from '@ds';
import { StatusGroup, useCasesBoardStore } from '@/store/cases-board.store';
import { CaseStatus } from '@/api/apis/case';
import { useCaseStatusCountForRow } from '@/queries/case';

type ChipProps = {
  onChipClick: (id: string) => void;
  status?: CaseStatus;
  group?: StatusGroup;
  id: string;
  title: string;
};

export const CasesBoardNavigationChip = ({ onChipClick, id, title, group, status }: ChipProps) => {
  const count = useCaseStatusCountForRow({ status, group });
  const hideEmpty = useCasesBoardStore((store) => store.hideEmpty);

  if (hideEmpty && !count) return null;

  return (
    <Chip
      size="lg"
      className="bg-base-60 hover:bg-base-40 cursor-pointer active:bg-base-10 active:text-base-80"
      onClick={() => onChipClick(id)}
    >
      <span className="text-m-m mr-2">{title}</span>
      <span className="text-m-sb">{count ?? 0}</span>
    </Chip>
  );
};
